import React from "react";
import CategorySelector from "./CategorySelector";

const Body: React.FC = () => {
  return <CategorySelector />;
};

export default Body;
